import Entity from '../entity'
import CharlieCampo from './charlieCampo'

export default class CharlieRegistro extends Entity<number>{
    listaCampos: Array<CharlieCampo> = [];
}